module.exports = __webpack_public_path__ + "img/Recurso 11.48a480d8.png";